import { useHookstate } from "@hookstate/core";
import { MESSAGE_COUNT, SITEID_GLOBAL_STATE, UPDATED_CAR_DATA_STATE } from "globalStore/globalStore";
import moment from "moment";
import { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { getFeatureSetOption, getFeaturesList, isUserAdmin, isUserSupport } from "constant";
import { validateCarType } from "_helperFunctions/validateCarType";

const useInboxMessagesCount = () => {
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const { MessageNumber } = useHookstate(MESSAGE_COUNT);
  const { updatedCarData } = useHookstate(UPDATED_CAR_DATA_STATE);
  const { getMessagesFromCarsData, getUserRole, siteSettingsData } =
    useSelector((state) => state.commonReducers) || [];
  const { carMessagesBackup } =
    useSelector((state) => state.firstReducer) || [];
  const [messageData, setMessageData] = useState([]);
  const enableMemberCar = isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role) ||
    !getFeatureSetOption(siteSettingsData?.Features, getFeaturesList().member_cars);
  useEffect(() => {
    if (!localStorage.getItem("dismissedIds")) {
      let tempData = [];
      localStorage.setItem("dismissedIds", JSON.stringify(tempData));
    }
  }, [localStorage.getItem("dismissedIds")]);
  useEffect(() => {
    if (siteId.get() !== null) {
      setMessageData([]);
      if (messageData.length !== 0) {
        messageData.forEach((msg) => {
          try {
            let dismissedIds = [];
            const dismissedIdsString = localStorage.getItem("dismissedIds");
            if (dismissedIdsString) {
              dismissedIds = JSON.parse(dismissedIdsString);
            }
            dismissedIds.push(msg?.Id);
            localStorage.setItem("dismissedIds", JSON.stringify(dismissedIds));
          } catch (error) {
            console.error("Error parsing dismissedIds in forEach:", error);
            // Reinitialize with current message ID
            localStorage.setItem("dismissedIds", JSON.stringify([msg?.Id]));
          }
        });
      }
    }
  }, [siteId.get()]);

  useEffect(() => {
    let dismissedIds = [];
    try {
      const dismissedIdsString = localStorage.getItem("dismissedIds");
      if (dismissedIdsString) {
        dismissedIds = JSON.parse(dismissedIdsString);
      }
    } catch (error) {
      console.error("Error parsing dismissedIds in useEffect:", error);
      localStorage.removeItem("dismissedIds"); // Clear corrupted data
    }
    
    let messageDataGetter = [] || [];
    if (carMessagesBackup && carMessagesBackup?.length !== 0) {
      messageDataGetter =
        getMessagesFromCarsData &&
        getMessagesFromCarsData?.Messages &&
        getMessagesFromCarsData?.Messages?.length !== 0 &&
        getMessagesFromCarsData?.Messages?.filter((item) => {
          if (!carMessagesBackup.includes(item.Id)) {
            return {
              ...item,
              id: item?.Id,
              received: moment(item?.Created).unix(),
              car: item?.CarNum,
              text: item?.Text,
              response: item?.Response,
              hole: item?.Hole,
            };
          }
        });
    } else {
      messageDataGetter =
        getMessagesFromCarsData &&
          getMessagesFromCarsData?.Messages &&
          getMessagesFromCarsData?.Messages?.length !== 0
          ? getMessagesFromCarsData?.Messages?.map((item, i) => {
            return {
              ...item,
              id: item?.Id,
              received: moment(item?.Created).unix(),
              car: item?.CarNum,
              text: item?.Text,
              response: item?.Response,
              hole: item?.Hole,
            };
          })
          : "";
    }
    if (messageDataGetter && messageDataGetter?.length !== 0) {
      let finalMessages = messageDataGetter?.filter(

        (msg) => {
          return !dismissedIds.includes(msg?.Id) && (enableMemberCar || validateCarType(msg?.CarNum, updatedCarData.get()))
        });
      setMessageData(finalMessages);
      MessageNumber.set(finalMessages.length);
    }
  }, [
    carMessagesBackup,
    getMessagesFromCarsData,
    localStorage.getItem("dismissedIds"),
  ]);

  return {
    msgInboxCount: messageData.length,
  };
};

export default useInboxMessagesCount;
